import {HttpMethod} from "../../common/SimpleType";
import DataModel from "../../model-factory/basic/data/DataModel";
import {IAnyObject} from "../../common/SimpleInterface";

export default class ApiRequestVO
{
    includeAuthorization:boolean|string;
    endpoint:string = "";
    httpMethod:HttpMethod = "GET";
    params:IAnyObject = {};
    dataModel:DataModel|null = null;
    isAdditionalData:boolean = false;

    constructor(includeAuthorization:boolean|string = false)
    {
        this.includeAuthorization = includeAuthorization;
    }
}